var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrid2D(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1439,
    height: 705,
    viewBox: "0 0 1439 705",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.367798 719.051H1439M-0.367798 663.692H1439M-0.367798 608.331H1439M-0.367798 552.971H1439M-0.367798 497.61H1439M-0.367798 442.25H1439M-0.367798 386.889H1439M-0.367798 331.53H1439M-0.367798 276.169H1439M-0.367798 220.809H1439M-0.367798 165.448H1439M-0.367798 110.089H1439M-0.367798 54.7277H1439M774.044 775.044V0M718.684 775.044V0M663.323 775.044V0M607.963 775.044L607.963 0M552.603 775.044V0M497.243 775.044L497.243 0M441.883 775.044L441.882 0M386.522 775.044L386.522 0M331.162 775.044L331.162 0M275.802 775.044L275.802 0M220.441 775.044L220.441 0M165.081 775.044L165.081 0M109.721 775.044L109.721 0M54.3605 775.044L54.3604 0M1383.01 775.044V0M1327.65 775.044V0M1272.29 775.044V0M1216.93 775.044V0M1161.57 775.044V0M1106.21 775.044V0M1050.85 775.044V0M995.485 775.044V0M940.125 775.044V0M884.765 775.044V0M829.405 775.044V0",
    stroke: "#0099cc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid2D);
export default __webpack_public_path__ + "static/media/grid-2d.6a4394b809570295372995d268a349e9.svg";
export { ForwardRef as ReactComponent };